import { Paper, styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

type WrapperProps = {
  bordered?: boolean;
  isLoading?: boolean;
};

const LOGIN_BOX_SHADOW = '0px 4px 8px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)';

export const Wrapper = styled(Paper, {
  shouldForwardProp: omitForwardedProps<WrapperProps>('isLoading', 'bordered'),
})<WrapperProps>(({ theme: { palette, shape, spacing, breakpoints }, bordered, isLoading }) => ({
  padding: spacing(4),
  width: 428,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),
  flexShrink: 0,
  overflow: 'hidden',
  background: palette.background.paper,
  border: `1px solid ${palette.grey[200]}`,
  boxShadow: LOGIN_BOX_SHADOW,
  ...(bordered && {
    borderRadius: shape.borderRadius * 2,
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    boxShadow: LOGIN_BOX_SHADOW,
  }),
  ...(isLoading && {
    height: 400,

    '& iframe': {
      visibility: 'hidden',
    },
  }),
  [breakpoints.down('sm')]: {
    border: 'none',
    boxShadow: 'none',
    width: '100%',
    padding: spacing(3, 0),
  },
}));

export const StyledIframe = styled('iframe')({
  border: 'none',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  '&&::-webkit-scrollbar': {
    display: 'none',
  },
});
